// global-toast.js

(function () {
    if (typeof document === 'undefined') return;
  
    document.addEventListener('DOMContentLoaded', function () {
      var root = document.querySelector('[data-global-toast]');
      if (!root) return;
  
      var inner = root.querySelector('[data-global-toast-inner]');
      var messageEl = root.querySelector('[data-global-toast-message]');
      var iconEl = root.querySelector('[data-global-toast-icon]');
      var closeBtn = root.querySelector('[data-global-toast-close]');
  
      var hideTimeout = null;
  
      function clearTimer() {
        if (hideTimeout) {
          clearTimeout(hideTimeout);
          hideTimeout = null;
        }
      }
  
      function hideToast() {
        clearTimer();
        root.classList.remove('global-toast--info', 'global-toast--success', 'global-toast--warning', 'global-toast--error');
        inner.classList.remove('is-visible');
        // pequeno delay para garantir animação de saída
        setTimeout(function () {
          root.hidden = true;
        }, 200);
      }
  
      function showToast(message, options) {
        options = options || {};
        var type = options.type || 'info'; // info | success | warning | error
        var duration = typeof options.duration === 'number' ? options.duration : 3000;
  
        clearTimer();
  
        // Mensagem
        if (messageEl) {
          messageEl.textContent = message;
        }
  
        // Ícone por tipo
        if (iconEl) {
          var iconChar = 'ℹ️';
          if (type === 'success') iconChar = '✔️';
          if (type === 'warning') iconChar = '⚠️';
          if (type === 'error') iconChar = '⛔';
          iconEl.textContent = iconChar;
        }
  
        // Classe de tipo
        root.classList.remove('global-toast--info', 'global-toast--success', 'global-toast--warning', 'global-toast--error');
        root.classList.add('global-toast--' + type);
  
        // Mostrar
        root.hidden = false;
        requestAnimationFrame(function () {
          inner.classList.add('is-visible');
        });
  
        // Auto-hide
        if (duration > 0) {
          hideTimeout = setTimeout(hideToast, duration);
        }
      }
  
      // Fecha no X
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          hideToast();
        });
      }
  
      // Expõe globalmente
      window.showToast = showToast;
    });
  })();
  